// 開発案件のピッカーに渡す候補の組み立て。UI は SearchableMaster（設備を登録の
// 担当者ピッカーと同じコンポーネント）をそのまま使うので、ここは候補の整形だけ。
// マスタは既存のものだけを読む（社員 / 部門 / 場所マスタ）。第2の一覧は作らない。

export function buildPersonSectionOptions(employees = [], departments = []) {
  return [
    ...(employees || []).filter((e) => e && e.name).map((e) => ({
      id: `emp-${e.id}`, name: e.name, hint: '社員',
      searchable: `${e.name} ${e.department_name || ''} ${e.code || ''}`,
    })),
    ...(departments || []).filter((d) => d && d.name).map((d) => ({
      id: `dept-${d.id}`, name: d.name, hint: '部門', searchable: d.name,
    })),
  ];
}

export function buildLocationOptions(locations = []) {
  return (locations || []).filter((l) => l && (l.code || l.name)).map((l) => ({
    id: l.id,
    name: `${l.code || ''}${l.name && l.name !== l.code ? ` — ${l.name}` : ''}`,
    hint: '場所マスタ',
    searchable: `${l.code || ''} ${l.name || ''} ${l.parent_name || ''}`,
  }));
}
